import trainersJson from "../generated/trainers.json" with { type: "json" };
import type { TrainerClassRecord, TrainerPartyRecord, TrainersFile } from "./types.js";

const TRAINERS = trainersJson as TrainersFile;
const classById = new Map(TRAINERS.classes.map((c) => [c.id, c]));

/**
 * Trainer payout (§5.8, `read_trainer_party.asm`): class base money per level × level of the last
 * party Pokémon. Returns 0 for an unknown class id. Accepts the raw class id (1–47) or the
 * `OPP_*` value (id + 200) stored in `wCurOpponent`.
 */
export function trainerPrize(trainerClass: number, lastMonLevel: number): number {
  const id = trainerClass > 200 ? trainerClass - 200 : trainerClass;
  const c = classById.get(id);
  if (!c || !Number.isInteger(lastMonLevel) || lastMonLevel < 0) return 0;
  return c.baseMoney * lastMonLevel;
}

/** Largest payout of any party the game can field (Champion: ₽99 × 65). */
export function maxTrainerPrize(): number {
  return TRAINERS.maxPrize;
}

export function trainerClasses(): TrainerClassRecord[] {
  return TRAINERS.classes.map((c) => ({ ...c }));
}

export function trainerParty(trainerClass: number, index: number): TrainerPartyRecord | null {
  const p = TRAINERS.parties.find((x) => x.trainerClass === trainerClass && x.index === index);
  return p ? structuredClone(p) : null;
}

export function trainerParties(): TrainerPartyRecord[] {
  return structuredClone(TRAINERS.parties);
}
